export default {"src":"/_next/static/media/angle-double-left.256317af.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};